export default function ServiceFlow() {
  const steps = [
    {
      number: '01',
      title: '案件のご紹介',
      description: '工務店様から太陽光発電に興味のある施主様の案件をご紹介いただきます。簡単な情報（住所・連絡先・図面）だけでOKです。',
      duration: '即日対応',
      icon: 'ri-phone-line',
      color: 'from-teal-400 to-emerald-400'
    },
    {
      number: '02',
      title: '施主様への商談代行',
      description: 'ライズの専門スタッフが施主様とwebや訪問にて直接商談いたします。太陽光発電のメリットや補助金情報など、専門的な説明を全て代行いたします。',
      duration: '約1〜2時間',
      icon: 'ri-presentation-line',
      color: 'from-emerald-400 to-green-400'
    },
    {
      number: '03',
      title: '現地調査・設計',
      description: '専門スタッフが現地調査を実施し、最適なシステム設計を行います。図面作成や詳細見積もりも全てお任せください。',
      duration: '約3〜5日',
      icon: 'ri-search-eye-line',
      color: 'from-cyan-400 to-teal-400'
    },
    {
      number: '04',
      title: 'ご契約・補助金申請',
      description: '施主様とのご契約手続きと補助金申請を全て代行。煩雑な書類作成や申請業務は全てライズコーポレーションが対応いたします。',
      duration: '約1〜2週間',
      icon: 'ri-file-paper-2-line',
      color: 'from-teal-400 to-cyan-400'
    },
    {
      number: '05',
      title: '施工・設置工事',
      description: '経験豊富な施工チームが責任を持って工事を実施。工務店様は現場管理の手間なく、安心してお任せいただけます。',
      duration: '約1〜3日',
      icon: 'ri-tools-line',
      color: 'from-green-400 to-emerald-400'
    },
    {
      number: '06',
      title: '完了・紹介料のお支払い',
      description: '施工完了後、検査・お引き渡しを行います。工務店様には案件紹介料をお支払いいたします。',
      duration: '約2〜4週間',
      icon: 'ri-checkbox-circle-line',
      color: 'from-emerald-400 to-teal-400'
    }
  ];

  return (
    <section id="service-flow" className="py-12 md:py-24 bg-gradient-to-b from-white to-teal-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-400 to-emerald-400 text-white px-4 py-1.5 md:px-8 md:py-3 rounded-full text-xs md:text-lg font-bold mb-4 md:mb-6 shadow-lg">
            <i className="ri-flow-chart text-base md:text-xl"></i>
            SERVICE FLOW
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-3 md:mb-4">
            案件紹介から<span className="text-teal-500">収益化</span>までの流れ
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto px-2">
            工務店様は案件をご紹介いただくだけ。あとは全てライズにお任せください。
          </p>
          <div className="w-16 md:w-20 h-1 md:h-1.5 bg-gradient-to-r from-teal-400 to-emerald-400 mx-auto mt-4 md:mt-6 rounded-full"></div>
        </div>

        {/* Desktop Timeline */}
        <div className="hidden lg:block relative">
          {/* Center Line */}
          <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-teal-300 via-emerald-300 to-green-300 transform -translate-x-1/2"></div>
          
          {steps.map((step, index) => (
            <div key={index} className={`relative flex items-center mb-12 last:mb-0 ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
              {/* Card */}
              <div className={`w-5/12 ${index % 2 === 0 ? 'pr-12 text-right' : 'pl-12 text-left'}`}>
                <div className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-6 border border-gray-100 hover:border-teal-200 hover:-translate-y-1 cursor-pointer">
                  <div className={`flex items-center gap-3 mb-3 ${index % 2 === 0 ? 'justify-end' : 'justify-start'}`}>
                    <div className={`w-12 h-12 bg-gradient-to-br ${step.color} rounded-xl flex items-center justify-center shadow-md ${index % 2 === 0 ? 'order-2' : 'order-1'}`}>
                      <i className={`${step.icon} text-white text-xl`}></i>
                    </div>
                    <h3 className={`text-xl font-bold text-gray-800 ${index % 2 === 0 ? 'order-1' : 'order-2'}`}>
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed mb-3">
                    {step.description}
                  </p>
                  <div className={`inline-flex items-center gap-1.5 bg-teal-50 text-teal-600 px-3 py-1 rounded-full text-xs font-medium`}>
                    <i className="ri-time-line"></i>
                    {step.duration}
                  </div>
                </div>
              </div>

              {/* Center Number Badge */}
              <div className="absolute left-1/2 transform -translate-x-1/2 z-10">
                <div className={`w-16 h-16 bg-white rounded-full border-4 border-teal-400 flex items-center justify-center shadow-lg`}>
                  <span className="text-xl font-bold text-teal-500">{step.number}</span>
                </div>
              </div>

              {/* Empty Space */}
              <div className="w-5/12"></div>
            </div>
          ))}

          {/* Free Badge */}
          <div className="absolute left-1/2 top-[32%] transform -translate-x-1/2 translate-y-8 z-20">
            <div className="bg-gradient-to-r from-orange-400 to-amber-400 text-white px-4 py-1.5 rounded-full text-xs font-bold shadow-lg whitespace-nowrap">
              工務店様の負担ゼロ！
            </div>
          </div>
        </div>

        {/* Mobile/Tablet Timeline */}
        <div className="lg:hidden relative">
          {/* Left Line */}
          <div className="absolute left-5 md:left-6 top-0 bottom-0 w-0.5 bg-gradient-to-b from-teal-300 via-emerald-300 to-green-300"></div>

          {steps.map((step, index) => (
            <div key={index} className="relative flex items-start mb-5 md:mb-6 last:mb-0">
              {/* Number Badge */}
              <div className="relative z-10 flex-shrink-0">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-full border-3 border-teal-400 flex items-center justify-center shadow-md">
                  <span className="text-sm md:text-base font-bold text-teal-500">{step.number}</span>
                </div>
              </div>

              {/* Card */}
              <div className="ml-3 md:ml-4 flex-1">
                <div className="bg-white rounded-xl shadow-md p-3 md:p-4 border border-gray-100">
                  <div className="flex items-center gap-2 mb-2">
                    <div className={`w-8 h-8 md:w-9 md:h-9 bg-gradient-to-br ${step.color} rounded-lg flex items-center justify-center shadow-sm`}>
                      <i className={`${step.icon} text-white text-sm md:text-base`}></i>
                    </div>
                    <h3 className="text-sm md:text-base font-bold text-gray-800">
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-gray-600 text-xs leading-relaxed mb-2">
                    {step.description}
                  </p>
                  <div className="inline-flex items-center gap-1 bg-teal-50 text-teal-600 px-2 py-0.5 rounded-full text-[10px] md:text-xs font-medium">
                    <i className="ri-time-line text-xs"></i>
                    {step.duration}
                  </div>
                </div>

                {/* Free Badge after step 3 */}
                {index === 2 && (
                  <div className="mt-2 md:mt-3 mb-1">
                    <div className="inline-flex bg-gradient-to-r from-orange-400 to-amber-400 text-white px-2.5 py-1 md:px-3 md:py-1 rounded-full text-[10px] md:text-xs font-bold shadow-md">
                      工務店様の負担ゼロ！
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* After Support Note */}
        <div className="mt-10 md:mt-16 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-2xl md:rounded-3xl p-5 md:p-10 text-center border border-teal-100">
          <div className="flex items-center justify-center gap-2 md:gap-3 mb-2 md:mb-4">
            <span className="text-2xl md:text-4xl">🛡️</span>
            <h3 className="text-base md:text-2xl font-bold text-gray-800">
              施工後のアフターフォローも完全対応
            </h3>
          </div>
          <p className="text-gray-600 text-xs md:text-base max-w-3xl mx-auto leading-relaxed">
            定期点検・メンテナンス・クレーム対応まで、全てライズコーポレーションが対応いたします。<br className="hidden md:block" />
            工務店様にご迷惑や負担をおかけすることなく、長期的な安心をご提供いたします。
          </p>
        </div>
      </div>
    </section>
  );
}